/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import React, { useContext, useEffect, useState } from "react";
import {
    Box,
    CircularProgress,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Select,
    MenuItem,
    Grid,
    Typography,
    Button,
    Autocomplete,
    Chip,
    TextField,
} from "@mui/material";
import { getGroups } from "apis/api";
import { getGrouping } from "./grouping";
import { GlobalRefContext } from "../../store/GlobalRefs";
import { createReport } from "./utils";
import { getAttorneys } from "apis/api";
import { getCustoms } from "apis/api";

const CUSTOM_TAB_MAX_RETRIES = 4;
const CUSTOM_TAB_RETRY_DELAY = 1500;
const DOWNLOAD_SPACING = 400;
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const Reports = ({
    rows,
    mattersRows,
    activitiesRows,
    pKeyeddata,
    activityKeyedData,
    activityAttorneyMatter,
    combinedInvalidActivities,
    pdata,
    customAdjRefreshKey
}

) => {
    const grefs = useContext(GlobalRefContext);
    const [runOption, setOption] = useState("all_groups");
    const [selectedAttorney, setSelectedAttorney] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState([]);
    const [groups, setGroups] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [results, setResults] = useState(null);
    const [showErrorsTable, setShowErrorsTable] = useState(false);
    const [errorSummary, setErrorSummary] = useState(null);
    const [attorneyList, setAttorneys] = useState([]);
    const [customTab, setCustomTab] = useState([]);
    const [loadingCustomTab, setLoadingCustomTab] = useState(false);
    const [loadingGroups, setLoadingGroups] = useState(true);
    const [groupsError, setGroupsError] = useState(null);
    useEffect(() => {
        // Re-read the custom adjustments whenever an upload re-calculated them,
        // so report generation never runs against the copy fetched on mount.
        getCustomsTab(customAdjRefreshKey > 0);

    }, [customAdjRefreshKey])

    const getAllGroups = async () => {
        setLoadingGroups(true);
        try {
            const ret = await getGroups();
            const groups = JSON.parse(ret.body);

            setGroups(groups);
            setGroupsError(null);
        } catch (error) {
            // Previously this failed silently, leaving `groups` empty — which makes the
            // "all groups" option quietly produce per-attorney reports and no group
            // reports at all.
            console.error("Error loading groups:", error);
            setGroupsError(error.message);
        } finally {
            setLoadingGroups(false);
        }
    };
    const getCustomsTab = async (waitForConsistency = false) => {
        setLoadingCustomTab(true);

        try {
            let ret = await getCustoms();

            // The calculation lambda empties the custom-adjustments table and re-inserts
            // every row, and getCustoms reads it back with an eventually consistent scan.
            // A read taken right after an upload can therefore still be partial, so poll
            // until two consecutive reads agree before using the data.
            if (waitForConsistency) {
                for (let attempt = 0; attempt < CUSTOM_TAB_MAX_RETRIES; attempt++) {
                    await delay(CUSTOM_TAB_RETRY_DELAY);

                    const next = await getCustoms();
                    const settled = next.length > 0 && next.length === ret.length;

                    ret = next;

                    if (settled) break;
                }
            }

            setCustomTab(ret);
        } catch (error) {
            console.error("Error loading custom adjustments:", error);
        } finally {
            setLoadingCustomTab(false);
        }
    };
    const handleOptionChange = (event) => {
        setOption(event.target.value);
    };
    // useEffect(() => {

    // }, [])

    useEffect(() => {
        // const convertToLabelValue = (input) => {
        //     console.log("inputt::", input);
        //     return input.data
        //         .map(item => ({ label: item.name, value: item.name })) // create label/value
        //         .sort((a, b) => a.label.localeCompare(b.label)); // optional: sort alphabetically
        // }

        // const res = await getAttorneys();
        //  console.log("Res get attorneys::", res);
        // const apiAttorneys = convertToLabelValue(res);
        // console.log("apiAttorneys", apiAttorneys)
        // Built from whatever has loaded. Previously this required pdata.expenses to
        // be present and dereferenced `.name` without a guard, so one matter with a
        // null responsible_attorney (only originating_attorney is filtered upstream)
        // threw here and left attorneyList empty — which silently drops every
        // unassigned attorney from the "all groups" run.
        if (mattersRows || activitiesRows) {
            const matters = Array.isArray(mattersRows) ? mattersRows : [];
            const activities = Array.isArray(activitiesRows) ? activitiesRows : [];

            const originating = matters.map((item) => item?.originating_attorney?.name);
            const responsible = matters.map((item) => item?.responsible_attorney?.name);

            const expenses = (Array.isArray(pdata?.expenses) ? pdata.expenses : []).map(
                (item) => item?.attorney
            );
            const newattorneys = []
                .concat(originating)
                .concat(responsible)
                .concat(expenses)
                .filter((item) => item && item !== "");
            const distinctAttorney = Array.from(new Set(newattorneys));

            const attorneyList = distinctAttorney.map((atty, i) => {
                return {
                    label: atty,
                    value: atty,
                };
            });
            const uniqueNamesAttorneys = [
                ...new Set(activities.map((entry) => entry?.user?.name).filter(Boolean)),
            ];

            // Step 2: Transform into desired format
            const distinctUsers = uniqueNamesAttorneys.map(name => ({
                label: name,
                value: name
            }));
            const merged = [
                ...new Map([...attorneyList, ...distinctUsers].map(item => [item.value, item])).values()
            ];



            setAttorneys(merged);
        }



    }, [mattersRows, pdata, activitiesRows]);


    useEffect(() => {
        getAllGroups();
    }, []);
    const onClick = async () => {
        setProcessing(true);
        setResults(null);
        setErrorSummary(null);

        // These refs live for the lifetime of the app and are keyed by row number, not
        // by attorney. Without clearing them, a second Validate in the same session
        // reuses the previous run's cached expense values (expenses.js skips
        // recalculating when calculatedCELGValues already has the attorney).
        grefs.calculatedPaymentValues.current = {};
        grefs.calculatedExpenseValues.current = {};
        grefs.calculatedCELGValues.current = {};
        grefs.sumFormulas.current = {};

        try {
            const filteredClioMatters = mattersRows.filter(
                (item) =>
                    item.originating_attorney?.name &&
                    item.responsible_attorney?.name &&
                    item.originating_attorney.name.trim() !== "" &&
                    item.responsible_attorney.name.trim() !== ""
            );

            const groupedData = getGrouping(
                groups,
                runOption,
                filteredClioMatters,
                pKeyeddata,
                activityKeyedData,
                activityAttorneyMatter
            );

            // NOTE: a block here used to map mattersRows to
            // `item.responsible_attorney.name` without a guard and then never use the
            // result. Upstream only filters out null originating_attorney, so a single
            // matter with no responsible attorney threw before the loop below and
            // aborted the entire run — zero reports, error only in the console.
            const distinctAttorney = [...new Set(attorneyList.map(a => a.value))];



            //get attorneys not in a group
            let assignedAttorneys = [];
            groups.forEach((group) => {
                assignedAttorneys = assignedAttorneys.concat(group.attorneys);
            });


            const nonGroupedAttorneys = distinctAttorney.filter((item) => {
                return !assignedAttorneys.includes(item);
            });



            const reportArray =
                runOption === "all_groups"
                    ? (() => {
                        const result = groups
                            .map((group) => group.id)
                            .concat(nonGroupedAttorneys);

                        console.log("testgroups::", result);
                        return result;
                    })()
                    : runOption === "select_attorneys"
                        ?
                        (() => {


                            console.log("selected::", selectedAttorney);
                            return selectedAttorney;
                        })()
                        : runOption === "select_group"
                            ? selectedGroup
                            : distinctAttorney;



            // Keep track of success/failure
            const processResults = [];


            // Process reports for each attorney — sequentially, with a pause between
            // downloads. Awaiting createReport alone is not enough pacing: the only
            // await inside is writeBuffer(), so saveAs used to fire in a tight burst
            // and browsers silently discard programmatic downloads that arrive while
            // the "Download multiple files?" prompt is pending.
            for (const [index, attorney] of reportArray.entries()) {
                try {
                    await createReport(
                        attorney,
                        rows,
                        groupedData.clioMatters,
                        groupedData.persistedKeyedData,
                        groupedData.clioActivitiesKeyed,
                        groupedData.clioActivitiesAttorneyMatters,
                        grefs,
                        customTab
                    );
                    processResults.push({ name: attorney, status: "success", error: null });
                } catch (error) {
                    console.error(`Error creating report for ${attorney}:`, error);
                    processResults.push({ name: attorney, status: "error", error: error.message });
                }

                if (index < reportArray.length - 1) {
                    await delay(DOWNLOAD_SPACING);
                }
            }

            // Automatically analyze and export error data
            const errorResults = analyzeAndExportErrors();
            setErrorSummary(errorResults);

            setResults({
                processResults,
                errorResults,
                requested: reportArray.length,
            });
        } catch (error) {
            console.error("Error processing reports:", error);
            setResults({
                error: error.message,
            });
        } finally {
            setProcessing(false);
        }
    };
    const exportActivitiesToCSV = (activities, filename) => {
        if (!activities || activities.length === 0) return;

        try {
            // First, flatten the nested objects for CSV export
            const flattenedActivities = activities.map((activity) => {
                const flattened = { ...activity };

                // Safely extract nested properties
                if (activity.matter && typeof activity.matter === "object") {
                    flattened.matter_id = activity.matter.id;
                    flattened.matter_display_number = activity.matter.display_number;
                    flattened.matter_description = activity.matter.description;
                    flattened.matter_status = activity.matter.status;
                    // Remove the original nested object
                    delete flattened.matter;
                }

                if (activity.user && typeof activity.user === "object") {
                    flattened.user_id = activity.user.id;
                    flattened.user_name = activity.user.name;
                    flattened.user_email = activity.user.email;
                    // Remove the original nested object
                    delete flattened.user;
                }

                if (activity.bill && typeof activity.bill === "object") {
                    flattened.bill_id = activity.bill.id;
                    flattened.bill_number = activity.bill.number;
                    // Remove the original nested object
                    delete flattened.bill;
                }

                // Clean up any remaining objects by converting to JSON strings
                Object.keys(flattened).forEach((key) => {
                    if (typeof flattened[key] === "object" && flattened[key] !== null) {
                        if (flattened[key] instanceof Set) {
                            flattened[key] = Array.from(flattened[key]).join(";");
                        } else {
                            flattened[key] = JSON.stringify(flattened[key]);
                        }
                    }
                });

                return flattened;
            });

            // Get all possible headers from all activities
            const allHeaders = new Set();
            flattenedActivities.forEach((activity) => {
                Object.keys(activity).forEach((key) => {
                    // Skip functions and complex objects
                    if (typeof activity[key] !== "function") {
                        allHeaders.add(key);
                    }
                });
            });

            // Convert to array and sort for consistent output
            const headers = Array.from(allHeaders).sort();

            // Create CSV content
            let csvContent = headers.join(",") + "\n";

            // Add each activity as a row
            flattenedActivities.forEach((activity) => {
                const row = headers.map((header) => {
                    const value = activity[header];

                    // Handle different value types
                    if (value === null || value === undefined) return "";
                    if (typeof value === "string")
                        return `"${value.replace(/"/g, '""')}"`;
                    return String(value);
                });

                csvContent += row.join(",") + "\n";
            });

            // Create and download the file
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");

            // Create a URL for the Blob
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `${filename}.csv`);

            // Append to the DOM, trigger click, and clean up
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up
            setTimeout(() => {
                URL.revokeObjectURL(url);
            }, 100);

            return true; // Indicate success
        } catch (error) {
            console.error(`Error exporting activities to CSV: ${error.message}`);
            return false; // Indicate failure
        }
    };

    // Function to automatically analyze and export error data
    const analyzeAndExportErrors = () => {
        const errorResults = {
            exportCount: 0,
            attorneys: [],
            unassigned: 0,
        };

        try {
            // First check the combinedInvalidActivities from our enhanced clio function
            if (combinedInvalidActivities && Object.keys(combinedInvalidActivities).length > 0) {
                Object.entries(combinedInvalidActivities).forEach(([category, activities]) => {
                    if (activities.length > 0) {
                        // Special handling for unassigned activities
                        if (category === "__UNASSIGNED__") {
                            if (exportActivitiesToCSV(activities, `unassigned_error`)) {
                                errorResults.exportCount++;
                                errorResults.unassigned = activities.length;
                            }
                        } else {
                            // Regular attorney activities
                            if (
                                exportActivitiesToCSV(
                                    activities,
                                    `${category.replace(/[^a-z0-9]/gi, "_").toLowerCase()}_error`
                                )
                            ) {
                                errorResults.exportCount++;
                                errorResults.attorneys.push({
                                    name: category,
                                    count: activities.length,
                                });
                            }
                        }
                    }
                });
            }
            // If we have allClioActivities but no combinedInvalidActivities, perform manual analysis
            else if (activitiesRows && activitiesRows.length > 0) {
                // Manually detect activities with issues
                const manualErrorsByAttorney = {};
                let unassignedErrors = [];

                activitiesRows.forEach((activity, index) => {
                    let hasError = false;
                    let errorReason = null;

                    // Check for basic validity
                    if (!activity) {
                        hasError = true;
                        errorReason = "Empty activity";
                    } else if (!activity.bill || typeof activity.bill !== "object") {
                        hasError = true;
                        errorReason = "Missing bill information";
                    } else if (!activity.matter || typeof activity.matter !== "object") {
                        hasError = true;
                        errorReason = "Missing matter information";
                    } else if (!activity.matter.display_number) {
                        hasError = true;
                        errorReason = "Missing matter display number";
                    }

                    if (hasError) {
                        // Add to appropriate category
                        if (activity && activity.user && activity.user.name) {
                            const attorney = activity.user.name;
                            if (!manualErrorsByAttorney[attorney]) {
                                manualErrorsByAttorney[attorney] = [];
                            }
                            manualErrorsByAttorney[attorney].push({
                                ...activity,
                                _errorReason: errorReason,
                                _index: index,
                            });
                        } else {
                            unassignedErrors.push({
                                ...activity,
                                _errorReason: errorReason || "Unknown error",
                                _index: index,
                            });
                        }
                    }
                });

                // Export any found errors
                Object.entries(manualErrorsByAttorney).forEach(
                    ([attorney, activities]) => {
                        if (activities.length > 0) {
                            if (
                                exportActivitiesToCSV(
                                    activities,
                                    `${attorney.replace(/[^a-z0-9]/gi, "_").toLowerCase()}_error`
                                )
                            ) {
                                errorResults.exportCount++;
                                errorResults.attorneys.push({
                                    name: attorney,
                                    count: activities.length,
                                });
                            }
                        }
                    }
                );

                if (unassignedErrors.length > 0) {
                    if (exportActivitiesToCSV(unassignedErrors, `unassigned_error`)) {
                        errorResults.exportCount++;
                        errorResults.unassigned = unassignedErrors.length;
                    }
                }
            }

            return errorResults;
        } catch (error) {
            console.error("Error analyzing and exporting error data:", error);
            return {
                error: error.message,
                exportCount: errorResults.exportCount,
                attorneys: errorResults.attorneys,
                unassigned: errorResults.unassigned,
            };
        }
    };


    const processResults = results?.processResults || [];
    const succeededReports = processResults.filter((item) => item.status === "success");
    const failedReports = processResults.filter((item) => item.status !== "success");

    return (
        <Box p={4} pb={20}>
            <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend" sx={{ mb: 2 }}>
                    Run Options
                </FormLabel>
                <RadioGroup value={runOption} onChange={handleOptionChange} name="run-options">
                    <FormControlLabel
                        value="all_groups"
                        control={<Radio />}
                        label="Run for all groups and unassigned attorneys"
                    />
                    <FormControlLabel
                        value="all_attorneys"
                        control={<Radio />}
                        label="Run for all attorneys"
                    />
                    <FormControlLabel value="select_attorneys" control={<Radio />} label="Select Attorneys" />
                    <FormControlLabel value="select_group" control={<Radio />} label="Select Group" />
                </RadioGroup>
            </FormControl>

            {/* Conditional Selects */}
            {runOption === "select_attorneys" && attorneyList && (
                <Box mt={2} mb={2} >
                    <Typography mb={1}>Select an Attorney</Typography>
                    <Autocomplete
                        pt={5}
                        multiple
                        options={attorneyList}
                        getOptionLabel={(option) => option.label}
                        value={attorneyList.filter((a) => selectedAttorney.includes(a.value))}
                        onChange={(event, newValue) => {
                            setSelectedAttorney(newValue.map((item) => item.value));
                        }}
                        renderTags={(tagValue, getTagProps) =>
                            tagValue.map((option, index) => (
                                <Chip
                                    key={option.value}
                                    label={option.label}
                                    {...getTagProps({ index })}
                                />
                            ))
                        }
                        renderInput={(params) => <TextField {...params} label="Select Attorneys" />}
                        sx={{
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            "& .MuiInputBase-root": {
                                padding: "6px",
                            },
                            "& .MuiChip-root": {
                                margin: "2px",
                            },
                        }}
                    />

                </Box>
            )
            }

            {
                runOption === "select_group" && (
                    <Box mt={2} mb={2}>
                        <Typography mb={1}>Select a Group</Typography>
                        <Autocomplete
                            multiple
                            options={groups}
                            getOptionLabel={(option) => option.id}
                            value={groups.filter((group) => selectedGroup.includes(group.id))}
                            onChange={(event, newValue) => {
                                setSelectedGroup(newValue.map((group) => group.id));
                            }}
                            renderTags={(tagValue, getTagProps) =>
                                tagValue.map((group, index) => (
                                    <Chip
                                        key={group.id}
                                        label={group.id}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Select Groups" />
                            )}
                            sx={{
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                "& .MuiInputBase-root": {
                                    padding: "6px",
                                },
                                "& .MuiChip-root": {
                                    margin: "2px",
                                },
                            }}
                        />
                    </Box>
                )
            }
            {loadingCustomTab && (
                <Box mt={2} mb={2} display="flex" alignItems="center">
                    <CircularProgress size={18} />
                    <Typography ml={1} variant="body2">
                        Loading the latest custom adjustments...
                    </Typography>
                </Box>
            )}
            {loadingGroups && (
                <Box mt={2} mb={2} display="flex" alignItems="center">
                    <CircularProgress size={18} />
                    <Typography ml={1} variant="body2">
                        Loading groups...
                    </Typography>
                </Box>
            )}
            {groupsError && (
                <Box mt={2} mb={2}>
                    <Typography variant="body2" color="error">
                        {`Groups could not be loaded (${groupsError}). Running now would produce no group reports.`}
                    </Typography>
                </Box>
            )}
            <Grid item xs={6}>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={onClick}
                    disabled={loadingCustomTab || loadingGroups || processing}
                    sx={{
                        backgroundColor: "#0bc011ff", // custom color
                        color: "#fff", // white text
                        "&:hover": {
                            backgroundColor: "#1565c0",
                        },
                    }}
                >
                    {loadingCustomTab || loadingGroups ? "Loading..." : "Validate"}
                </Button>
            </Grid>

            {/* Run summary. Previously `results` was computed but never rendered, so a
                report that failed for one attorney was indistinguishable from one that
                was never requested. */}
            {results && (
                <Box mt={3}>
                    {results.error ? (
                        <Typography color="error">
                            {`The run failed before any report was generated: ${results.error}`}
                        </Typography>
                    ) : (
                        <>
                            <Typography variant="subtitle2" mb={1}>
                                {`${succeededReports.length} of ${results.requested} reports generated`}
                            </Typography>

                            {failedReports.length > 0 && (
                                <Box mb={1}>
                                    <Typography color="error" variant="body2" mb={0.5}>
                                        {`${failedReports.length} failed:`}
                                    </Typography>
                                    {failedReports.map((item) => (
                                        <Typography key={item.name} variant="body2" color="error">
                                            {`• ${item.name} — ${item.error}`}
                                        </Typography>
                                    ))}
                                </Box>
                            )}

                            {results.requested === 0 && (
                                <Typography color="error" variant="body2">
                                    Nothing was selected to run. If you chose &quot;all groups&quot;,
                                    the attorney list may not have loaded yet — reload the Data page
                                    and try again.
                                </Typography>
                            )}

                            {succeededReports.length > 0 && (
                                <Box mt={1} display="flex" flexWrap="wrap" gap={0.5}>
                                    {succeededReports.map((item) => (
                                        <Chip key={item.name} label={item.name} size="small" color="success" />
                                    ))}
                                </Box>
                            )}

                            {errorSummary && errorSummary.exportCount > 0 && (
                                <Typography variant="caption" color="text.secondary" display="block" mt={1}>
                                    {`${errorSummary.exportCount} error CSV file(s) exported for activities with missing matter data.`}
                                </Typography>
                            )}
                        </>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default Reports;
